module.exports = __webpack_public_path__ + "media/images/skype-eee9dc5e85da7ce83d27f78a9637c875.svg";